function markValidation(restrict) {
  return function () {
    return {
      restrict: restrict,
      require: '^form',
      link: function (scope, element, attrs, formCtrl) {
        scope.$applyAsync(() => {
          const names = angular
            .element(element[0].querySelectorAll('[ng-model]'))
            .map('attr', 'name');
          const test = attrs.markInvalidIf;
          if (names.length) {
            let wasInvalid = false;
            scope.$watch(
              function () {
                let pending = !wasInvalid && formCtrl.$pending;
                return (
                  !pending &&
                  names.some((name) => {
                    // Mark a control invalid if the field is invalid and one of the following is true:
                    // - The form has been submitted
                    // - The field has been touched AND is not pristine (has been modified)
                    // leftoverText is a fix for ngTagsInput
                    let t =
                      formCtrl &&
                      formCtrl[name] &&
                      !formCtrl[name].$valid &&
                      (isFormSubmitted(formCtrl) ||
                        (formCtrl[name].$touched &&
                          (!formCtrl[name].$pristine ||
                            formCtrl[name].$error.leftoverText)));
                    if (test) {
                      t = t || scope.$eval(test);
                    }
                    return t;
                  })
                );
              },
              function (isInvalid) {
                wasInvalid = isInvalid;
                element.toggleClass('has-error', isInvalid);
              },
            );
          }
        });
      },
    };
  };
}

function isFormSubmitted(form) {
  /* eslint-disable angular/no-private-call */
  while (!form.$submitted && form.$$parentForm && form.$$parentForm.$name) {
    form = form.$$parentForm;
  }
  /* eslint-enable */
  return form.$submitted;
}

/**
 * @name MarkValidation
 * @docType shared
 * @category function
 * @description
 * Marks bootstrap validation classes on the given element, based on
 * the first input with an ng-model it finds.
 * @param restrict {string} - restrict parameter for directives ('AEC' or any combination)
 * @returns directive descriptor {function} - a function that returns a Directive Definition Object
 */
export const markValidationComponentModule = angular
  .module('Q.components.forms.mark-validation', [])
  .value('isFormSubmitted', isFormSubmitted)
  .directive('markValidation', markValidation('A'))
  .directive('formGroup', markValidation('C'));
